"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishedRosterDTO = exports.PublishedRosterTimeEntryDTO = exports.PublishedRosterVenueDTO = exports.PublishedRosterDepartmentDTO = exports.PublishedRosterEmployeeDTO = exports.TimeEntryPublishedInfoDTO = void 0;
const class_transformer_1 = require("class-transformer");
const time_entry_type_1 = require("../../time-entries/time-entry-type");
const safe_assign_1 = require("./safe-assign");
class TimeEntryPublishedInfoDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.TimeEntryPublishedInfoDTO = TimeEntryPublishedInfoDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeEntryPublishedInfoDTO.prototype, "time", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "deleted", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "employeeId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TimeEntryPublishedInfoDTO.prototype, "date", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "positionId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "startPlanned", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "endPlanned", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TimeEntryPublishedInfoDTO.prototype, "comment", void 0);
class PublishedRosterEmployeeDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.PublishedRosterEmployeeDTO = PublishedRosterEmployeeDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PublishedRosterEmployeeDTO.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PublishedRosterEmployeeDTO.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], PublishedRosterEmployeeDTO.prototype, "positions", void 0);
class PublishedRosterDepartmentDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.PublishedRosterDepartmentDTO = PublishedRosterDepartmentDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PublishedRosterDepartmentDTO.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PublishedRosterDepartmentDTO.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PublishedRosterDepartmentDTO.prototype, "color", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PublishedRosterDepartmentDTO.prototype, "order", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], PublishedRosterDepartmentDTO.prototype, "rosterOrder", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], PublishedRosterDepartmentDTO.prototype, "archived", void 0);
class PublishedRosterVenueDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.PublishedRosterVenueDTO = PublishedRosterVenueDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PublishedRosterVenueDTO.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PublishedRosterVenueDTO.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], PublishedRosterVenueDTO.prototype, "enabledHolidays", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], PublishedRosterVenueDTO.prototype, "departments", void 0);
class PublishedRosterTimeEntryDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.PublishedRosterTimeEntryDTO = PublishedRosterTimeEntryDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], PublishedRosterTimeEntryDTO.prototype, "start", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "startPlanned", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "endPlanned", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "deleted", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PublishedRosterTimeEntryDTO.prototype, "date", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], PublishedRosterTimeEntryDTO.prototype, "isPast", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "published", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "position", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PublishedRosterTimeEntryDTO.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "employeeId", void 0);
class PublishedRosterDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.PublishedRosterDTO = PublishedRosterDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], PublishedRosterDTO.prototype, "roster", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => PublishedRosterTimeEntryDTO),
    __metadata("design:type", Array)
], PublishedRosterDTO.prototype, "timeEntries", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => PublishedRosterEmployeeDTO),
    __metadata("design:type", Array)
], PublishedRosterDTO.prototype, "employees", void 0);
//# sourceMappingURL=published-roster.dto.js.map